// Libraries
import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { BookingComponent } from '../BookingComponent';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as $ from 'jquery';
// Services
import { BookingHolidayService } from '../../../services';
import { SessionStorageService, FileService, CatalogService, LocalStorageService } from '../../../../common/modules/core/services';
//Models
import { ClassChild, BookingItem } from '../../../models';
import { Questionnaire, Answer } from '../../../models/QuestionAnswer';

@Component({
    selector: 'question-answer',
    template: require('./QuestionAnswerComponent.html'),
    styles: [require('./QuestionAnswerComponent.sass')]
})

export class QuestionAnswerComponent extends BookingComponent implements OnInit {

    //children
    private selectedChild: any;
    private children: any;
    private clases: any[] = [];
    // Q&A
    private questionnaires: Questionnaire[] = []
    private answerList: Answer[] = [];
    //booking
    private booking: any;
    private showNoteModal: Boolean = false;
    private hasError: Boolean = false;

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected services: BookingHolidayService,
        protected sessionStorageService: SessionStorageService,
        protected local: LocalStorageService
    ) {
        super(router, services, sessionStorageService);
    }

    ngOnInit() {
        // Retrieve holiday children from session
        this.children = this.getHolidayChildren();
        // Get selected child
        this.selectedChild = this.getSelectedChild();
        //check class avaiable
        this.getAvailableClasses();
        // Get questionaire
        this.getAllQuestionnaire();
  
    }


    // Retrieve all available classes for selected child by his dob
    getAvailableClasses() {
        let query = {
            "date_of_birth": this.timeDataFormat(this.selectedChild.date_of_birth, 'YYYY-MM-DD'),
            "limit": 100,
            "page": 1
        }

        // Get courses arcordingly to selected child dob
        this.services.getClasses(query).subscribe(
            result => {
                // Get clases
                this.clases = _.filter(result.data, {'status': 'opened'});
                // Default set full period
                if(!this.clases || !this.clases.length){
                    //throw popup
                    this.showNoteModal = true;
                }
            },
            error => {

            }
        )
    }

    checkQAExist(){
        if(this.getBooking()){
            //check for booking create in session
            this.booking = this.getBooking();
            //check for QA info exist
            if(this.booking.question_answer && this.booking.question_answer.length > 0){
                this.setAnswers(this.booking.question_answer);
                //remove QA from session
                this.sessionStorageService.removeData('answerList');
            }
            else{
                //get QA from session
                if(this.getQuestionAnswer()){
                    let answerList:any = this.getQuestionAnswer();
                    this.setAnswers(answerList);
                    //set answerList into booking session
                    this.booking.question_answer = answerList;
                }
            }
        }
        else{

            //get QA from session
            if(this.getQuestionAnswer()){
                let answerList:any = this.getQuestionAnswer();
                this.setAnswers(answerList);
            }
        }
    }

    onCloseNoteModal(event: any){
        this.showNoteModal = false;
        this.backToStudentList();
    }

    getAllQuestionnaire() {
        this.services.getQuestionnaire(true).subscribe(
            result => {
                // Get excursions
                // this.questionnaires = result;
                if (result && result.length) {
                    let res: Questionnaire[] = result;
                    _.forEach(_.orderBy(res,['order']), (val, key) => {
                        let item: Questionnaire = {
                            id: val.id,
                            order: val.order,
                            question: val.question,
                            answer: val.answer,
                            choosen_answer: null
                        };
                        this.questionnaires.push(item);
                    })

                    //check for questionaire in booking and session
                    this.checkQAExist();
                }
            },
            error => {

            }
        )
    }


    private updateQAForBooking(){
        
    }


    private setAnswers(answerList: Answer[]){
        _.forEach(answerList , (val) => {
            _.forEach(this.questionnaires, (valQ) => {
                if(val.question_id == valQ.id)
                    valQ.choosen_answer = val.answer;
            });
        });
    }


    private submitQuestion(isValid: boolean) {
        if(isValid){
            _.forEach(this.questionnaires, (val, key) => {
                let item: Answer = {
                    question_id: val.id,
                    answer: val.choosen_answer
                }
                this.answerList.push(item)
            })
    
            if(this.booking){
                this.booking.question_answer = this.answerList;
                this.setBooking(this.booking);
            }
            else{
                // Set answerList to session
                this.setQuestionAnswer(this.answerList);
            }
            //  Navigate to activities page
            this.toActivitiesListPage();
        }
        else{
            this.hasError = true;
            let flag = false;
            _.forEach(this.questionnaires, (val, key) => {
                let item: Answer = {
                    question_id: val.id,
                    answer: val.choosen_answer
                }
                if(item.answer)
                    flag = true;
            });
            if(!flag){
                //if all radio not checked , show only first error
                setTimeout(function(){ 
                    $('.custom-danger').not(':first').hide();
                    $('.custom-danger').first().focus();
                 }, 10);
            }
            else{
                setTimeout(function(){ 
                    $('.custom-danger').show();
                    $('.custom-danger').first().focus();
                 }, 10);
            }
        }

    }
}




// WEBPACK FOOTER //
// ./src/holiday/parent/booking/2-Q&A/QuestionAnswerComponent.ts